export const NAMESPACE = 'KanBo/userAvatars/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'

const initialState = {}

export const userAvatarDefaults = {
  src: null,
  isLoading: false,
  isLoaded: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.profileKey]: {
          ...userAvatarDefaults,
          ...state[action.payload.profileKey],
          ...action.payload.data
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(userAvatar => {
        newState[userAvatar.profileKey] = {
          ...userAvatarDefaults,
          ...newState[userAvatar.profileKey],
          ...userAvatar
        }
      })
      return newState
    }
    default: return state
  }
}

export function add ({ profileKey, data }) {
  return {
    type: ADD,
    payload: {
      profileKey,
      data
    }
  }
}

export function addArray (userAvatarsArray) {
  return {
    type: ADD_ARRAY,
    payload: userAvatarsArray
  }
}
